/**
 * ConvertDateToSearchDate
 *
 * Converts a given date into the format need to be passed on to the API
 *
 * @return {function}
 */

OT.createNS('OT.Search.Helpers.convertDateToSearchDate');

OT.Search.Helpers.convertDateToSearchDate = function (date, time) {

    time = OT.Search.Helpers.convertTimeTo24Hour(time);

    var dateTime = date.replace(/\//g, '-') + ' ' + time,
        dateFormat = Resources.Strings.DateFormat.toUpperCase().replace(/\//g, '-') + ' HH:mm';

    return moment(dateTime, dateFormat).format('YYYY-MM-DD HH:mm');

};
